import { LogLevel } from "@azure/msal-browser";

const clientId = process.env.VUE_APP_MSAL_CLIENT_ID;
const authority = process.env.VUE_APP_MSAL_AUTHORITY;

if (!clientId || !authority) {
  throw new Error("Missing VUE_APP_MSAL_CLIENT_ID or VUE_APP_MSAL_AUTHORITY");
}

const origin = globalThis.location.origin;

export const loginRequest = {
  scopes: (process.env.VUE_APP_MSAL_SCOPES || `api://${clientId}/newmy-prod`)
    .split(",")
    .map((scope) => scope.trim())
    .filter(Boolean),
};

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI || origin,
    postLogoutRedirectUri:
      process.env.VUE_APP_MSAL_POST_LOGOUT_REDIRECT_URI || `${origin}/login`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback(level, message, containsPii) {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error("[MSAL]", message);
        if (level === LogLevel.Warning) console.warn("[MSAL]", message);
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};
